import React, { useState } from 'react';
import { HiTrash } from 'react-icons/hi';
import { FaEdit } from 'react-icons/fa';
import moment from 'moment';
import { StrategyMapMilestone } from './SmapMilestoneMapper';
import './SmapMilestoneCard.css';
import ConfirmationDialog from '../../../../pages/DashboardNew/components/ConfirmationDialog';

interface SmapMilestoneCardProps {
    milestone: StrategyMapMilestone;
    onRemove: () => void;
    onEdit?: (data: StrategyMapMilestone) => void;
}

const SmapMilestoneCard: React.FC<SmapMilestoneCardProps> = ({
    milestone,
    onRemove,
    onEdit
}) => {
    const [deleteConf, setDeleteConf] = useState<{
        show: boolean;
        position?: { top: number; left: number };
    }>({ show: false });

    const handleRemoveClick = (e: React.MouseEvent) => {
        const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
        setDeleteConf({
            show: true,
            position: {
                top: rect.top,
                left: rect.left - 215
            }
        });
    };

    return (
        <div className="smap-milestone-card shadow-sm border border-light-border dark:border-hover-dark rounded-xl overflow-hidden bg-light-surfacePrimary dark:bg-secondary-dark font-sans">
            <div className="p-3 flex items-center justify-between">
                <div className="flex items-center gap-3 min-w-0">
                    <div 
                        className="w-3 h-3 rounded-full flex-shrink-0 animate-pulse" 
                        style={{ backgroundColor: milestone.color || '#3b82f6', boxShadow: `0 0 8px ${milestone.color || '#3b82f6'}80` }}
                    />
                    <div className="min-w-0">
                        <h4 className="text-sm font-bold text-light-text-primary dark:text-white truncate" title={milestone.name}>
                            {milestone.name}
                        </h4>
                        <p className="text-[11px] text-light-text-muted dark:text-gray-400 mt-0.5">
                            {milestone.start_date ? moment(milestone.start_date).format('MMM DD, YYYY') : 'No date set'}
                        </p>
                    </div>
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                    {onEdit && (
                        <button
                            className="p-1.5 rounded-md hover:bg-light-status-info-bg dark:hover:bg-blue-900/20 text-light-text-secondary dark:text-gray-400 hover:text-light-status-info-text dark:hover:text-blue-200 transition-colors duration-200"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(milestone);
                            }}
                            title="Edit milestone"
                        >
                            <FaEdit size={14} />
                        </button>
                    )}
                    <button
                        className="p-1.5 rounded-md hover:bg-light-status-error-bg dark:hover:bg-red-900/20 text-light-text-secondary dark:text-gray-400 hover:text-light-status-error-text dark:hover:text-red-400 transition-colors duration-200"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveClick(e);
                        }}
                        title="Delete milestone"
                    >
                        <HiTrash size={14} />
                    </button>
                </div>
            </div>

            <ConfirmationDialog
                isOpen={deleteConf.show}
                type="single"
                position={deleteConf.position}
                dependencyName={milestone.name}
                entityLabel="milestone"
                onConfirm={() => {
                    onRemove();
                    setDeleteConf({ show: false });
                }}
                onCancel={() => setDeleteConf({ show: false })}
            />
        </div>
    );
};

export default SmapMilestoneCard;
